import { setActiveTabIndex } from "@store";
import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";
import { Nav, NavItem, TabContent, TabPane, NavLink } from "reactstrap";

import { ActionsButtons } from "./ActionsButtons";
import { BasketOptions } from "./BasketOptions";
import { General } from "./General";
import { Header } from "./Header";
import { Menu } from "./Menu";
import { ProductView } from "./ProductView";

export function Design(): JSX.Element {
    const { t } = useTranslation();

    const tabs: TabsType[] = [
        {
            title: "General",
            content: <General />,
            customClassName: "cgt_txt_general",
        },
        {
            title: "Header",
            content: <Header />,
            customClassName: "cgt_txt_enteteInterfaceGenerique",
        },
        {
            title: "Menu",
            content: <Menu />,
        },
        {
            title: "Product view",
            content: <ProductView />,
            customClassName: "",
        },
        {
            title: "Basket and options",
            content: <BasketOptions />,
            customClassName: "",
        },
        {
            title: "Actions Buttons",
            content: <ActionsButtons />,
            customClassName: "cgt_txt_actionButtonsGenericInterface",
        },
    ];

    const [activeTab, setActiveTab] = React.useState<number>(0);

    function toggleNav(tab: number) {
        if (activeTab !== tab) setActiveTab(tab);
        setActiveTabIndex(tab);
    }

    return (
        <div className="design-container-items__clz">
            <div
                style={{
                    width: "85%",
                    height: "96%",
                    backgroundColor: "#EDEDED",
                }}
                className="m-2 border-0 rounded"
            >
                <div className="p-2 mt-1 text-center font-weight-bold cursor__clz">
                    {t("Setup options")}
                </div>
                <Nav tabs className="mt-2">
                    {tabs.map((element, index) => {
                        const words = element.title.trim().split(" ");

                        let formattedTitle;

                        if (words.length === 1) {
                            const word = words[0];
                            formattedTitle =
                                word.charAt(0).toLowerCase() + word.slice(1);
                        } else {
                            const pascalCase = words
                                .map(
                                    (word) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1).toLowerCase()
                                )
                                .join("");
                            formattedTitle =
                                pascalCase.charAt(0).toLowerCase() +
                                pascalCase.slice(1);
                        }

                        const itemClassName = `cgt_txt_${formattedTitle}`;
                        return (
                            <NavItem key={index} style={{ width: "100%" }}>
                                <NavLink
                                    className={classNames(
                                        `nav-link__clz ${itemClassName}`,
                                        {
                                            "active design-tab-nav-tabs-active-link__clz":
                                                activeTab === index,
                                        },
                                        element.customClassName
                                    )}
                                    onClick={() => {
                                        toggleNav(index);
                                        setActiveTabIndex(index);
                                    }}
                                >
                                    <span className="mx-2">
                                        {t(element.title)}
                                    </span>
                                </NavLink>
                            </NavItem>
                        );
                    })}
                </Nav>
            </div>

            <TabContent
                activeTab={activeTab}
                style={{ width: "100%", height: "95%" }}
            >
                {tabs.map((element, index) => {
                    return (
                        <TabPane
                            tabId={index}
                            style={{ height: "100%", width: "100%" }}
                            key={index}
                        >
                            {element.content}
                        </TabPane>
                    );
                })}
            </TabContent>
        </div>
    );
}
